import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MobilePostMessageName } from 'app/projects/shared/src/lib/enums/mobile-postMessage.enum';

declare var MobileApp: {
    postMessage(text: String): any;
};

@Injectable({
    providedIn: 'root',
})
export class ContentAccessExitService {
    static readonly CONTENT_UNAVAILABLE_PATH = '/errors/content-unavailable';

    readonly isKmpAppActive: boolean;

    constructor(private _router: Router) {
        const mobileAppValue = localStorage.getItem('kmpMobileApp');
        this.isKmpAppActive = mobileAppValue === 'ios' || mobileAppValue === 'android';
    }

    /** Closes the mobile WebView via the existing legacy NavigateBack contract. */
    closeWebView(): void {
        window.postMessage({ action: MobilePostMessageName.NavigateBack }, '*');

        try {
            MobileApp.postMessage(MobilePostMessageName.NavigateBack);
        } catch (e) {}
    }

    /**
     * Intentional leave (e.g. cancel enrollment): close EWA on KMP, otherwise navigate on web.
     */
    leaveContext(webFallbackUrl = '/modules'): void {
        if (this.isKmpAppActive) {
            this.closeWebView();
            return;
        }

        void this._router.navigateByUrl(webFallbackUrl);
    }

    /**
     * Broken / inaccessible deep link: go to the shared content-unavailable screen
     * (KMP auto-closes from that page via NavigateBack).
     */
    handleUnavailableContent(): void {
        void this._router.navigateByUrl(ContentAccessExitService.CONTENT_UNAVAILABLE_PATH);
    }
}
